<template>
  <el-sub-menu
    :index="menu.id"
    v-if="menu.children"
    @click.once="getId(menu.videoCode)"
  >
    <template #title>
      <span>{{ menu.name }}</span>
    </template>
    <sub-menu1
      :menu="menuItem"
      v-for="menuItem in menu.children"
      :key="menuItem.id"
    >
      <span>&nbsp;&nbsp;</span>
      <span>{{ menuItem.name }}</span>
    </sub-menu1>
  </el-sub-menu>
  <el-menu-item :index="menu.id" v-else @click="getId(menu.videoCode, menu)">
    <template #title>
      <span>&nbsp;</span>
      <span v-if="menu.click">
        <img src="../../../assets/liveimg1.gif" alt="" /> {{ menu.name }}
      </span>
      <span v-else>{{ menu.name }}</span>
    </template>
  </el-menu-item>
</template>

<script>
export default {
  name: "SubMenu1",
  components: {},
  props: {
    menu: Array,
    id: Number,
    name: String,
    chineseName: String,
    childMenu: Array,
  },
  data() {
    return {
      videoCode: "",
    };
  },
  mounted() {},
  methods: {
    getId(e) {
      if (e == "") {
        return;
      }
      this.videoCode = e;
      this.$bus.emit("videoCode1", this.videoCode);
    },
    fresh() {
      this.play = false;
    },
  },
};
</script>

<style scoped lang="less"></style>
